import { HelpOutlineOutlined } from '@mui/icons-material';
import { Tooltip } from '@sb/cc-design-system';
import { useState } from 'react';
import { lang } from 'src/utils';

import { ControlButton } from '../playbackControls/PlaybackControls.styled';

export const HelpButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={lang.helpButtonTitle}
      maxWidth={160}
      disableHoverListener
      open={open}
      onClose={() => setOpen(false)}>
      <ControlButton onClick={() => setOpen(!open)}>
        <HelpOutlineOutlined />
      </ControlButton>
    </Tooltip>
  );
};
